/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  isMAS,
  isNewYork,
}) {
  return questionnaire.map(question => {
    if (question.idQuestion === 760) {
      if (!isMAS && !isNewYork) {
        question.disabled = true;
        question.answer = "100";
      }
    }
    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  updatedObligorGroup,
  setObligorGroup,
}) {
  try {
    if (question.idQuestion === 759) {
      setObligorGroup(handleSelectedObligorCodings({
        updatedObligorGroup,
      }));
    }

  } catch (e) {
    console.log('OBLIGOR_PERC - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  setObligorGroup,
  updatedObligorGroup,
  setFieldValue,
  setFieldError,
  mc,
}) {
  try {
    if (question.idQuestion === 760) {
      setObligorGroup(updatedObligorGroup);
      handleObligorCodingTotal({
        obligorGroup: updatedObligorGroup,
        setFieldValue,
        setFieldError,
        mc,
      })
    }

  } catch (e) {
    console.log("OBLIGOR_PERC - handleQuestionBlur error", e)
  }
}

function handleSelectedObligorCodings({
  updatedObligorGroup,
}) {
  const selectedObligorCodings = updatedObligorGroup.map((group) => group.find((question) => question.idQuestion === 759)?.idAnswerOption);

  const newUpdatedObligorGroup = updatedObligorGroup.map((group) => {
    group.map((question) => {
      if (question.idQuestion === 759) {
        question.answerOptions = question.answerOptions.map((option) => {
          option.behaviorObject = {
            ...option.behaviorObject,
            isReadOnly: selectedObligorCodings.includes(option.idAnswerOption)
          }

          return option;
        });
      }

      return question;
    })

    return group;
  });

  return newUpdatedObligorGroup
}

function handleObligorCodingTotal({
  obligorGroup,
  setFieldValue,
  setFieldError,
  mc,
}) {
  const obligorCodingTotal = obligorGroup.reduce((acc, group) => {
    const obligorCodingPercentage = group.find((question) => question.idQuestion === 760)?.answer;
    return acc + (obligorCodingPercentage ? parseFloat(obligorCodingPercentage) : 0);
  }, 0);

  setFieldValue(`obligorCodingTotal`, obligorCodingTotal);

  obligorGroup.forEach((group) => {
    const obligorPercentageQuestion = group.find((q) => q.idQuestion == 760);
    setFieldError(obligorPercentageQuestion.key, obligorCodingTotal > 100 ? " " : "");
  });

  if (obligorCodingTotal > 100) {
    mc.error("The total obligor coding percentage should be 100%.");
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleSelectedObligorCodings,
  handleObligorCodingTotal,
};

export { events };